var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { EXPERIENCE } from "../../../constants";
import classNames from "classnames";
import { completedPage } from "../../../lib/Avo";
import { setEditingRemarketingPolicy } from "../../applicant/applicantSlice";
import { setPrefillStatus } from "../../unlinked-application/unlinkedApplicationSlice";
import { updateConfiguration } from "../../configuration/configurationSlice";
import useAccountReferenceId from "../../../services/savvy/useAccountReferenceId";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import useMemoryHistory from "../../../hooks/useMemoryHistory";
export default function EditPolicyButton(_a) {
    var nextRoute = _a.nextRoute;
    var history = useMemoryHistory();
    var dispatch = useAppDispatch();
    var getAccountReferenceId = useAccountReferenceId().getAccountReferenceId;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    return (React.createElement("button", { className: classNames("absolute right-[52px] top-4 rounded-[4px] border border-savvy-100 px-2 pb-1 pt-1.5 text-sm font-bold uppercase leading-none text-savvy"), onClick: function (ev) {
            getAccountReferenceId();
            dispatch(setEditingRemarketingPolicy(true));
            dispatch(setPrefillStatus({
                auto: { data: false, issuer: false },
                home: { data: false, issuer: false },
            }));
            dispatch(updateConfiguration({ experience: EXPERIENCE.SAVVY }));
            completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: ev.currentTarget.textContent, optionSelected: ev.currentTarget.textContent }));
            history.push(nextRoute);
        } }, "Edit"));
}
